import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import { useMarkdownMediaProcessor } from '@festina-life/ui/markdown'
import { SimpleModal } from '@festina-life/ui/structure'
import cx from 'classnames'
import { useState } from 'react'

import { changelogAssetsMap } from '../../changelog/assetsMap'
import changelog from '../../changelog/Changelog.md?raw'
import { ChangelogMarkdownViewer } from './ChangelogMarkdownViewer'

export const ChangelogModalButton = () => {
  const [isChangelogModalOpen, setIsChangelogModalOpen] = useState(false)
  const translate = useTranslate()
  const processedChangelog = useMarkdownMediaProcessor(
    changelog,
    changelogAssetsMap,
  )
  const changelogParts = processedChangelog.split('---\n\n').filter(Boolean)

  return (
    <>
      <SimpleModal
        isOpen={isChangelogModalOpen}
        title={translate('changelogModal.title')}
        closeConfiguration={{ onClose: () => setIsChangelogModalOpen(false) }}
        bodyOuterClassName="w-[90vw] h-[90vh] max-w-[90vw] max-h-[90vh]"
      >
        {changelogParts.map((part, index) => (
          <div
            className={cx(
              'rounded-md p-2 my-2',
              paperStyles({ isFaded: true }),
            )}
            // oxlint-disable-next-line react/no-array-index-key
            key={index}
          >
            <ChangelogMarkdownViewer>{part}</ChangelogMarkdownViewer>
          </div>
        ))}
      </SimpleModal>
      <Button
        onClick={() => setIsChangelogModalOpen(true)}
        startIcon="ListBullet"
      >
        {translate('changelogModal.button')}
      </Button>
    </>
  )
}
